import React from 'react';

import './Badge.scss';

function Badge(props) {
  const { color = '', children = null } = props;
  return (
    <span className={`badge state-color state-color-${color}`}>{children}</span>
  );
}

export default Badge;
